var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "url(#paint0_linear_552_2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5209 7.56055C14.6502 8.01915 14.9828 8.24845 15.4815 8.26755C15.9988 8.26755 16.3313 8.05736 16.4791 7.56055C19.4163 7.84717 22.6305 10.5032 22.9631 14.5542C23.3325 18.9873 20.0813 22.7707 15.8695 22.9809C11.5653 23.2102 8 19.6752 8 15.2421C8 10.9236 11.2697 7.9236 14.5209 7.56055ZM15.5185 9.05099C12.2118 9.05099 9.53325 11.8026 9.53325 15.223C9.53325 18.6433 12.1933 21.4141 15.5 21.4332C18.7882 21.4332 21.4668 18.6816 21.4852 15.2421C21.4852 11.8408 18.8067 9.05099 15.5185 9.05099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5552 6.35669C15.1488 6.35669 14.7239 6.35669 14.3175 6.35669C14.0035 6.35669 13.8372 6.18471 13.8372 5.84076C13.8372 5.70701 13.8372 5.57325 13.8372 5.43949C13.8187 5.19108 14.0035 5 14.2436 5C15.1118 5 15.9985 5 16.8668 5C17.1069 5 17.2732 5.19108 17.2916 5.42038C17.3101 5.57325 17.3101 5.74522 17.2916 5.89809C17.2732 6.16561 17.0884 6.33758 16.8298 6.33758C16.4049 6.35669 15.9801 6.35669 15.5552 6.35669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5178 6.58594C15.6656 6.58594 15.8318 6.58594 15.9796 6.58594C16.0535 6.58594 16.1089 6.60505 16.0905 6.70059C16.0905 6.9681 16.0905 7.23562 16.0905 7.50314C16.0905 7.67511 15.9981 7.80887 15.8318 7.86619C15.6102 7.96173 15.3885 7.96173 15.1853 7.8853C15.0006 7.82798 14.9082 7.67511 14.9082 7.48403C14.9082 7.21651 14.9082 6.9681 14.9082 6.70059C14.9082 6.60505 14.9451 6.58594 15.019 6.58594C15.1853 6.58594 15.3516 6.58594 15.5178 6.58594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3897 10.293C15.5006 10.293 15.6114 10.293 15.7222 10.293C15.7222 10.3503 15.7222 10.4076 15.7222 10.4649C15.7222 11.7834 15.7222 13.1019 15.7222 14.4204C15.7222 14.5159 15.7407 14.5732 15.8516 14.6114C16.2025 14.7643 16.3873 15.1274 16.3134 15.4904C16.2395 15.8726 15.9439 16.121 15.5745 16.121C15.2235 16.121 14.9094 15.8535 14.8355 15.5095C14.7617 15.1274 14.9279 14.7643 15.2974 14.6114C15.4082 14.5732 15.4267 14.5159 15.4267 14.4012C15.4267 13.0828 15.4267 11.7643 15.4267 10.4649C15.3897 10.4267 15.3897 10.3694 15.3897 10.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 14.668C16.6076 14.4387 16.4598 14.2285 16.2012 14.152C16.6445 13.7125 17.0694 13.2539 17.4943 12.8145C17.6421 12.9864 17.8268 13.1584 17.993 13.3304C17.5682 13.789 17.1433 14.2285 16.6999 14.668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_2",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    stopColor: "#A48242"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: 1,
    stopColor: "#B99450"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white",
    transform: "translate(8 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.7b14d1f6631dcc9afbed84e74380303b.svg";
export { ForwardRef as ReactComponent };